import { useEffect, useState } from "react";
import MeuUsuarioService from "../../services/resource/meuUsuarioService";

const meuUsuarioService = new MeuUsuarioService();

const CARGOS_AUTORIZADOS = ["SUPERVISOR", "COORDENADOR", "GERENTE"];

/**
 * Usado pelos processos de RH (Desligamento, Promoção/Enquadramento/Transferência) que só podem
 * ser iniciados por quem ocupa cargo de liderança — mesma regra do backend
 * (CargoAutorizacaoUtil.temCargoGerencial), reaplicada aqui só pra UX (evitar que a pessoa
 * preencha o formulário inteiro pra descobrir no fim que não pode enviar). O backend é quem
 * realmente garante a regra.
 */
export function useCargoGerencial() {
    const [carregando, setCarregando] = useState(true);
    const [autorizado, setAutorizado] = useState(false);
    const [filial, setFilial] = useState(null);

    useEffect(() => {
        let cancelado = false;
        meuUsuarioService.buscarPerfil()
            .then(res => {
                if (cancelado) return;
                const perfil = res.data || {};
                const isAdmin = (perfil.perfis || []).includes("ADMIN");
                const cargo = (perfil.cargo || "").toUpperCase();
                const temCargo = CARGOS_AUTORIZADOS.some(c => cargo.includes(c));
                setAutorizado(isAdmin || temCargo);
                setFilial(perfil.filialId)
            })
            .catch(() => {
                if (!cancelado) setAutorizado(false);
            })
            .finally(() => {
                if (!cancelado) setCarregando(false);
            });
        return () => { cancelado = true; };
    }, []);

    return { carregando, autorizado, filial };
}
